import {clearPhone} from '@/services/string';
import BaseService from '@/services/base_service';
import AuthService from '@/services/auth';

export default class UserService extends BaseService {
   authService = new AuthService();

   list(params) {
      return new Promise((resolve, reject) => {
         axios.get('/usuarios', params).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
   get(id) {
      return new Promise((resolve, reject) => {
         axios.get('/usuarios/' + id).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
   create(model) {
      return new Promise((resolve, reject) => {
         var user = _.clone(model);
         user.telefone = clearPhone(user.telefone);

         axios.post('/usuarios', user).then(response => {
            resolve(response);
         }).catch(e => {
            reject(this.getErrors(e));
         });
      });
   }
   update(model) {
      return new Promise((resolve, reject) => {
         var user = _.clone(model);
         user.telefone = clearPhone(user.telefone);
         axios.put('/usuarios/' + user.id, user).then(response => {
            resolve(response);
         }).catch(e => {
            reject(this.getErrors(e));
         });
      });
   }
   delete(id) {
      return new Promise((resolve, reject) => {
         axios.delete('/usuarios/' + id).then(response => {
            resolve(response);
         }).catch(e => {
            reject(e);
         });
      });
   }
  async changePassword(model) {
    try {
      let userStorage = this.authService.getUser();

      let response = await axios.put('/usuarios/alterar-senha', model);
      if (response.status === 200) {
          userStorage.token = btoa(userStorage.email + ':' + model.senha);
          this.authService.setUser(userStorage);
      }

      return response;
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js